import { render, staticRenderFns } from "./LpuPhonebook.vue?vue&type=template&id=1658ce57&scoped=true&"
import script from "./LpuPhonebook.vue?vue&type=script&lang=ts&setup=true&"
export * from "./LpuPhonebook.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./LpuPhonebook.vue?vue&type=style&index=0&id=1658ce57&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1658ce57",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1658ce57')) {
      api.createRecord('1658ce57', component.options)
    } else {
      api.reload('1658ce57', component.options)
    }
    module.hot.accept("./LpuPhonebook.vue?vue&type=template&id=1658ce57&scoped=true&", function () {
      api.rerender('1658ce57', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuPhonebook/LpuPhonebook.vue"
export default component.exports